// src/api.js
const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://indodeftech.com/api";
const TOKEN = process.env.REACT_APP_ADMIN_TOKEN || "IndoDef@2025";

export async function apiFetch(endpoint, opts = {}) {
  const url = `${API_BASE}/${endpoint}`;
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    ...(opts.headers || {}),
  };
  const options = { ...opts, headers };

  const res = await fetch(url, options);
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (e) {
    // return text if not JSON (for debugging)
    return { error: "Invalid JSON response", raw: text };
  }
}
